import React from 'react'
import { useTranslation } from 'react-i18next'

const Footer: React.FC<{ classes?: string }> = ({ classes }) => {
  const { t } = useTranslation()
  return (
    <footer
      className={`flex justify-center items-end p-4 text-xs text-muted-foreground ${classes ?? ''}`}
    >
      {t('footer')}
    </footer>
  )
}

export default Footer
